import styled from 'styled-components';
import { CheckboxType } from './Checkbox';
export const CheckboxAfter = styled.div `
  position: absolute;
  display: none;
`;
export const CheckboxSpan = styled.span `
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 2rem;
  width: 2rem;

  border-radius: ${({ theme, checkboxType }) => checkboxType === CheckboxType.PRIMARY
    ? theme.borderRadius.low
    : theme.borderRadius.highest};
  border: 1px solid
    ${({ hasError, theme, isChecked }) => hasError
    ? theme.colors.text.critical
    : isChecked
        ? theme.colors.borders.highlight
        : theme.colors.borders.default};

  ${({ checkboxType, theme, isChecked }) => checkboxType === CheckboxType.TERTIARY &&
    isChecked &&
    `border-color: ${theme.colors.interactive.brandColor}`};

  background-color: ${({ theme, isChecked }) => isChecked
    ? theme.colors.interactive.brandColor
    : theme.colors.surface.interactiveDefault};

  ${({ theme, checkboxType }) => checkboxType === CheckboxType.TERTIARY &&
    `background-color: ${theme.colors.surface.default}`};

  cursor: pointer;
  transition: all 0.3s ease;

  ${({ theme }) => {
    const borderColor = theme.colors.borders.highlight;
    const backgroundColor = theme.colors.surface.hover;
    const strokeColor = theme.colors.interactive.brandColor;
    return theme.media.laptop `
      &:hover {
        border-color: ${borderColor}
        background-color: ${backgroundColor}

        ${CheckboxAfter} {
          path {
            stroke: ${strokeColor}
          }
        }
      }
    `;
}}
`;
export const CheckboxButtonContainer = styled.div `
  position: relative;
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
`;
export const CheckboxInput = styled.input `
  position: relative;
  height: 100%;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.medium - 1};

  opacity: 0;

  cursor: pointer;

  &:checked {
    ~ ${CheckboxSpan} {
      ${CheckboxAfter} {
        display: flex;
        path {
          stroke: ${({ theme }) => theme.colors.surface.default};
        }
      }
      &:hover {
        ${CheckboxAfter} {
          path {
            ${({ theme, disabled }) => !disabled && `stroke: ${theme.colors.interactive.brandColor};`}
          }
        }
      }
    }
  }
  &:disabled {
    ~ ${CheckboxSpan} {
      border: 1px solid ${({ theme }) => theme.colors.borders.disabled};

      background-color: ${({ theme }) => theme.colors.surface.disabled};

      ${CheckboxAfter} {
        path {
          stroke: ${({ theme }) => theme.colors.borders.disabled};
        }
      }
    }
  }
`;
export const CheckboxLabel = styled.div `
  display: flex;
  align-items: start;
  min-width: 2rem;
  cursor: pointer;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  color: ${({ hasError, theme }) => hasError ? 'red' : theme.colors.text.default};
`;
export const LabelWrapper = styled.label `
  padding-left: 1.2rem;
  width: 100%;

  cursor: pointer;
`;
export const CircleIcon = styled.div `
  height: 0.8rem;
  width: 0.8rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
`;
//# sourceMappingURL=style.js.map